import React from 'react';
import cx from 'classnames';

import { IForeignRow } from '@treelab/panda';
import Reference from './Item';

import './index.css';

export interface IRefCollectionProps {
  /** Optional passed classname. */
  className?: string;
  /** Ref collection to pass */
  foreignRows: IForeignRow[];
  /** Helper for the right margin */
  includeSpace?: boolean;
  /** Pixel margin to the right */
  marginRight?: number;
}

export const RefCollection: React.FC<IRefCollectionProps> = ({
  className,
  foreignRows,
  includeSpace = true,
}) => {
  const combinedClass = cx({
    'panda-ref-collection': true,
    [className || '']: !!className,
  });
  const combinedRefClass = cx({
    'panda-ref--margin': includeSpace,
  });

  return (
    <div className={combinedClass} style={{}}>
      {foreignRows.map((foreignRow, i) => (
        <Reference className={combinedRefClass} item={foreignRow} key={foreignRow.id} />
      ))}
    </div>
  );
};
